import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ArpioSharedModule } from '../shared/arpio-shared.module'
import { ArpioRoutingModule } from './arpio-routing.module'
import { ArpioRootComponent } from './components/arpio-root/arpio-root.component'
import { TestPageComponent } from './components/test-page/test-page.component'
import { AccountModule } from 'src/app/account/account.module'
import { ArpioAlertModule } from './arpio-alert/arpio-alert.module'

@NgModule({
  declarations: [ArpioRootComponent, TestPageComponent],
  imports: [CommonModule, ArpioRoutingModule, ArpioSharedModule, AccountModule, ArpioAlertModule],
})
export class ArpioModule {}
